import { Address } from '@/types/Address';
import { translateAccents } from './translateCharacterAccents';

export const isFromUS = (country?: string) => {
    if (!country) {
        return false;
    }
    const lower = country.toLowerCase().replace(' ', '').trim();
    return lower === 'unitedstates' || lower === 'usa' || lower === 'us';
};

export const translateAddressAccents = (form: any) => {
    if (!form) {
        return form;
    }
    return {
        address: translateAccents(form.address),
        address1: translateAccents(form.address1),
        address2: translateAccents(form.address2),
        city: translateAccents(form.city),
        country: translateAccents(form.country),
        firstName: translateAccents(form.firstName),
        lastName: translateAccents(form.lastName),
        mobile: translateAccents(form.mobile),
        mobileNumber: translateAccents(form.mobileNumber),
        state: translateAccents(form.state),
        zip: translateAccents(form.zip),
        zipcode: translateAccents(form.zipcode),
    };
};

export const getAddressForCatalog = (catalog: any = {}, seller: any = {}) => {
    const { address: catalogAddress = {} } = catalog;
    if (catalogAddress?.address1) {
        const {
            address1 = '',
            address2 = '',
            city = '',
            country = 'USA',
            fullCountryName = 'United States',
            lat,
            lng,
            postalCode = '',
            state = '',
        } = catalogAddress;
        return {
            address1,
            address2,
            city,
            country: fullCountryName,
            countryCode: country,
            lat,
            lng,
            postalCode,
            stateCode: state,
        };
    } else {
        const {
            address = '',
            address2 = '',
            city = '',
            country = 'United States',
            countryCode = 'us',
            stateCode = '',
            zip,
        } = seller;
        const { lat, lng } = catalogAddress;
        return {
            address1: address,
            address2,
            city,
            country,
            countryCode,
            lat,
            lng,
            postalCode: zip,
            stateCode,
        };
    }
};

export const transformAddressFromCatalog = (catalogAddress) => {
    const {
        address1 = '',
        address2 = '',
        city = '',
        country = 'USA',
        firstName = '',
        fullCountryName = 'United States',
        lastName = '',
        mobileNumber = '',
        postalCode = '',
        state = '',
    } = catalogAddress;
    return {
        address: address1,
        address2,
        city,
        country,
        countryCode: fullCountryName,
        firstName,
        lastName,
        mobileNumber,
        state,
        zip: postalCode,
    } as Address;
};

export const transformAddressForStripe = (form) => {
    if (!form) {
        return form;
    }
    return {
        address_line1: form.address || form.address1,
        address_line2: form.address2,
        city: form.city,
        country: form.country,
        phone_number: form.mobileNumber,
        postal_code: form.zip,
        state: form.state,
    };
};

export const transformAddressForSquare = (form) => {
    if (!form) {
        return form;
    }
    return {
        address1: form.address || form.address1,
        address2: form.address2,
        city: form.city,
        country: form.country,
        postalCode: form.zip,
        state: form.state,
    };
};

export const getBidderReviewLocation = (city = '', state = '', country = '') => {
    const newCity =
        city.length > 3
            ? (' ' + city)
                  .toLowerCase()
                  .replace(/ (\w)/g, (str) => {
                      return str.toUpperCase();
                  })
                  .trim()
            : city.toUpperCase();
    const newState =
        state.length > 3
            ? (' ' + state)
                  .toLowerCase()
                  .replace(/ (\w)/g, (str) => {
                      return str.toUpperCase();
                  })
                  .trim()
            : state.toUpperCase();
    const newCountry =
        country.length > 3
            ? (' ' + country)
                  .toLowerCase()
                  .replace(/ (\w)/g, (str) => {
                      return str.toUpperCase();
                  })
                  .trim()
            : country.toUpperCase();

    let returnString = '';
    if (isFromUS(newCountry) && Boolean(newCity) && Boolean(newState)) {
        returnString = `${newCity}, ${newState}`;
    } else if (Boolean(newCity) && Boolean(newCountry)) {
        returnString = `${newCity}, ${newCountry}`;
    }
    return returnString;
};
